// extracted by mini-css-extract-plugin
export default {"root":"PrivacyPageComponent-root","radioGroup":"PrivacyPageComponent-radioGroup","legend":"PrivacyPageComponent-legend"};